/**
 * Brand/Back button — top-left of the HUD.
 *
 * 独立部署期间：点击重新进入当前页面（reload）。
 */
import { useTranslation } from 'react-i18next';
import { Button } from '@heroui/react';
import { Pill } from './PillPrimitives';

export function BrandButton() {
  const { t } = useTranslation();

  function handleClick() {
    window.location.reload();
  }

  return (
    <Pill horizontal={false} className="rounded-[44px]">
      <Button
        isIconOnly
        aria-label={t('toolbar.goBack')}
        onPress={handleClick}
        className="rounded-[40px]"
      >
        <img src="./logo.svg" width={40} height={40} alt="MindCloud XAI" />
      </Button>
    </Pill>
  );
}
